import { render } from "./Notices.vue?vue&type=template&id=37d56cf0"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
script.render = render

export default script